import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import type { GatewayProgressionNode as GatewayProgressionNodeType } from "@/lib/pharmacyFirst/types";

interface GatewayProgressionNodeProps {
  node: GatewayProgressionNodeType;
  isDarkMode?: boolean;
  onContinue: () => void;
}

export function GatewayProgressionNode({
  node,
  isDarkMode = false,
  onContinue,
}: GatewayProgressionNodeProps) {
  return (
    <div className="space-y-4">
      <Alert className="bg-blue-50 border-blue-200">
        <CheckCircle className="h-5 w-5 text-blue-600" />
        <AlertTitle className="text-lg font-bold mt-2 text-blue-900">
          {node.heading}
        </AlertTitle>
        <AlertDescription className="mt-2 text-base text-blue-800 whitespace-pre-line">
          {node.body}
        </AlertDescription>
      </Alert>

      <div className="flex gap-2">
        <Button onClick={onContinue} size="lg" className="w-full">
          Continue
        </Button>
      </div>
    </div>
  );
}
